import { render } from "./DynamicRadioForm.vue?vue&type=template&id=4353b57d&scoped=true"
import script from "./DynamicRadioForm.vue?vue&type=script&lang=ts"
export * from "./DynamicRadioForm.vue?vue&type=script&lang=ts"

import "./DynamicRadioForm.vue?vue&type=style&index=0&id=4353b57d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4353b57d"

export default script